module.exports = __webpack_public_path__ + "img/24.9b9d62c4.png";